export const SAVE_SIGN = 'SAVE_SIGN';
export const REQUEST_CODE = 'REQUEST_CODE';
export const VERIFY_CODE_SUCCESS = 'VERIFY_CODE_SUCCESS';
export const VERIFY_CODE_ERROR = 'VERIFY_CODE_ERROR';
export const HOW_DID_YOU_HEAR = 'HOW_DID_YOU_HEAR';
export const CLEAR_STORED_SIGNUP_DATA = 'CLEAR_STORED_SIGNUP_DATA';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_KIOSK_TOKEN = 'REFRESH_KIOSK_TOKEN';
export const TEMP_USER_TO_REGULAR = 'TEMP_USER_TO_REGULAR';
export const LOGOFF = 'LOGOFF';
export const SHOW_PAGE = 'SHOW_PAGE';
export const UPLOAD_STARTED = 'UPLOAD_STARTED';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_FINISHED = 'UPLOAD_FINISHED';
export const INVALIDATE_USER = 'INVALIDATE_USER';
export const SHOW_OVERLAYING_MODAL = 'SHOW_OVERLAYING_MODAL';
export const HIDE_OVERLAYING_MODAL = 'HIDE_OVERLAYING_MODAL';
export const SHOW_CHANGE_PASSWORD_ERROR = 'SHOW_CHANGE_PASSWORD_ERROR';
export const HIDE_CHANGE_PASSWORD_ERROR = 'HIDE_CHANGE_PASSWORD_ERROR';
export const SAVE_INFO = 'SAVE_INFO';
export const GET_MEMBERSHIP_AGREEMENT = 'GET_MEMBERSHIP_AGREEMENT';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const UPDATE_ORDERS = 'UPDATE_ORDERS';
export const UNUPDATE_ORDER = 'UNUPDATE_ORDER';
export const SHOW_REQUEST_CODE_ERROR = 'SHOW_REQUEST_CODE_ERROR';
export const UNSET_CURRENT_PRODUCT = 'UNSET_CURRENT_PRODUCT';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const DECREASE_REWARD_POINTS = 'DECREASE_REWARD_POINTS';
export const ADD_ORDER = 'ADD_ORDER';
export const CONCAT_ORDERS = 'CONCAT_ORDERS';
export const CHECKOUT_STARTED = 'CHECKOUT_STARTED';
export const CHECKOUT_FINISHED = 'CHECKOUT_FINISHED';

export const HOLD_PRODUCT = 'HOLD_PRODUCT';
export const HOLD_PRODUCT_RESET = 'HOLD_PRODUCT_RESET';
export const SET_PRODUCTS_STATE = 'SET_PRODUCTS_STATE';

export const GET_TAXES_SUCCESS = 'GET_TAXES_SUCCESS';
export const CLEAR_TAXES = 'CLEAR_TAXES';

export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS';
export const GET_SUMMARY_FAIL = 'GET_SUMMARY_FAIL';
export const TICKET_CALC_DATA_RECEIVED = 'TICKET_CALC_DATA_RECEIVED';
export const SET_SUMMARY_FETCHING = 'SET_SUMMARY_FETCHING';
export const CLEAR_SUMMARY = 'CLEAR_SUMMARY';
export const SET_PURCHASE_LIMITS_EXCEEDED = 'SET_PURCHASE_LIMITS_EXCEEDED';

// config
export const DELIVERY_COST = 'DELIVERY_COST';
export const MINIMUM_DELIVERY_QUANTITY = 'MINIMUM_DELIVERY_QUANTITY';
export const ALLOW_ADULT_USE_SIGNUPS = 'ALLOW_ADULT_USE_SIGNUPS';
export const secondaryColor = 'secondaryColor';
export const primaryColor = 'primaryColor';
export const ECOMMERCE_DELIVERY_NOTES = 'ECOMMERCE_DELIVERY_NOTES';
export const AGREEMENT_MEDICAL_USE = 'AGREEMENT_MEDICAL_USE';
export const AGREEMENT_ADULT_USE = 'AGREEMENT_ADULT_USE';
export const CUSTOMER_TYPE_ALLOW = 'CUSTOMER_TYPE_ALLOW';
export const DEFAULT_PATIENT_TYPE = 'DEFAULT_PATIENT_TYPE';
export const ORDERING_DISABLED = 'ORDERING_DISABLED';
export const AGE_RESTRICTION = 'AGE_RESTRICTION';
export const DELIVERY_MINIMUM_TOTAL = 'DELIVERY_MINIMUM_TOTAL';
export const ECOMMERCE_ADDRESS_RADIUS = 'ECOMMERCE_ADDRESS_RADIUS';
export const PLACE_ORDER = 'PLACE_ORDER';
export const ESTIMATED_TAX_DISCLAIMER_TEXT = 'ESTIMATED_TAX_DISCLAIMER_TEXT';
export const PURCHASE_RESTRICTIONS = 'PURCHASE_RESTRICTIONS';
export const ECOMMERCE_CHECKOUT_PAY_NOW_BUTTON_LABEL = 'ECOMMERCE_CHECKOUT_PAY_NOW_BUTTON_LABEL';
export const ECOMMERCE_CHECKOUT_PAY_LATER_BUTTON_LABEL = 'ECOMMERCE_CHECKOUT_PAY_LATER_BUTTON_LABEL';
export const ACH_PROVIDER_JS_LIBRARY_URL = 'ACH_PROVIDER_JS_LIBRARY_URL';
export const CURRENT_ACH_PROVIDER = 'CURRENT_ACH_PROVIDER';
export const ACH_ENABLED = 'ACH_ENABLED';
export const GOOGLE_RECAPTCHA_SITE_KEY = 'GOOGLE_RECAPTCHA_SITE_KEY';

export const SALES_CHANNEL_NAME = 'SALES_CHANNEL_NAME';

export const kioskModeType = {
    ONLINE_MENU: '',
    PAYMENT_KIOSK: 'tevanokiosk',
    SELF_SERVICE_KIOSK: 'selfservice',
    DPOS: 'dpos',
    MAIN_BOARD: 'readonly'
  };

export const STATE_ABBREV_MAP = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AS': 'American Samoa',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District Of Columbia',
  'FM': 'Federated States Of Micronesia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'GU': 'Guam',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MH': 'Marshall Islands',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'MP': 'Northern Mariana Islands',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PW': 'Palau',
  'PA': 'Pennsylvania',
  'PR': 'Puerto Rico',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VI': 'Virgin Islands',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};


// WEBPACK FOOTER //
// ./src/config/const.js